import { render, staticRenderFns } from "./SignProviderSelector.vue?vue&type=template&id=5ecb2ed5&scoped=true&"
import script from "./SignProviderSelector.vue?vue&type=script&lang=js&"
export * from "./SignProviderSelector.vue?vue&type=script&lang=js&"
import style0 from "./SignProviderSelector.vue?vue&type=style&index=0&id=5ecb2ed5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecb2ed5",
  null
  
)

export default component.exports